import { Injectable, Injector } from '@angular/core';
import { CrudBaseService } from './base/crud-base.service';
import { Observable } from 'rxjs';
import { ApplicationCertificationRequest, ApplicationCertificationResponse } from '../models/application-certification.model';
import { ReportType } from '../enums/report-type';

@Injectable({
    providedIn: 'root',
})
export class ApplicationCertificationService extends CrudBaseService<ApplicationCertificationRequest, ApplicationCertificationResponse> {
    constructor(injector: Injector) {
        super(injector, 'lh-application-certification');
    }

    getCertification(applicationid: number): Observable<ApplicationCertificationResponse> {
        return this.http.get<ApplicationCertificationResponse>(`${this.baseUrl}/${this.endpoint}/${applicationid}`);
    }

    calculateEligibility(participantid: number, applicationid: number): Observable<ApplicationCertificationResponse> {
        return this.http.post<ApplicationCertificationResponse>(`${this.baseUrl}/${this.endpoint}/calculate-eligibility/${participantid}/${applicationid}`, null);
    }

    createCertification(params: ApplicationCertificationRequest): Observable<ApplicationCertificationResponse> {
        return this.http.post<ApplicationCertificationResponse>(`${this.baseUrl}/${this.endpoint}`, params);
    }

    generateReport(participantId: number, applicationId: number, reportType: ReportType): Observable<any> {
        const reportTypeUrl = reportType === ReportType.Pdf ? 'Pdf' : reportType;
        return this.http.get<any>(`${this.baseUrl}/${this.endpoint}/${participantId}/${applicationId}/${reportTypeUrl}`, {
            responseType: 'blob' as 'json',
        });
    }
}